var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5319 16H14.4681C13.6487 16 13 16.6414 13 17.4517V24.6931C13 25.4865 13.6487 26.1448 14.4681 26.1448H16.5337V46.215C16.5337 47.0084 17.1824 47.6667 18.0018 47.6667H45.9982C46.8005 47.6667 47.4663 47.0252 47.4663 46.215V26.1448H49.5319C50.3342 26.1448 51 25.5034 51 24.6931V17.4517C51 16.6583 50.3513 16 49.5319 16ZM35.5508 40.1889H27.7323C27.1177 40.1889 26.6226 39.6994 26.6226 39.0917C26.6226 38.484 27.1177 37.9945 27.7323 37.9945H35.5508C37.6846 37.9945 39.4259 36.2727 39.4259 34.1628C39.4259 32.0528 37.6846 30.331 35.5508 30.331H26.1447L28.5175 32.6773C28.9443 33.0993 28.9443 33.8083 28.5175 34.2303C28.2956 34.4497 28.0225 34.551 27.7323 34.551C27.442 34.551 27.1689 34.4497 26.947 34.2303L22.6792 30.0103C22.5768 29.909 22.4915 29.7909 22.4403 29.6558C22.3208 29.3857 22.3208 29.0819 22.4403 28.8118C22.4915 28.6768 22.5768 28.5586 22.6792 28.4574L26.947 24.2374C27.3738 23.8154 28.0907 23.8154 28.5175 24.2374C28.9443 24.6594 28.9443 25.3683 28.5175 25.7903L26.1447 28.1366H35.5508C38.9137 28.1366 41.6451 30.8374 41.6451 34.1628C41.6451 37.4881 38.9137 40.1889 35.5508 40.1889Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnDeliveryIcon);
export default __webpack_public_path__ + "static/media/return-delivery-icon.135aaf5b62682c900363163e0d1c4d61.svg";
export { ForwardRef as ReactComponent };